<template lang="">
  <div class="cardContent flex">
    <a href="http://mmsgdsj.maoming.gov.cn/lzlogo" target="_blank">
      <img class="center-logo" src="~images/index/cyzl/mm_logo.png" />
    </a>

    <div
      :class="'pp-item pp-item' + (i + 1)"
      v-for="(item, i) in list"
      :key="i"
      @click="onppClick(item)"
    >
      <img :src="item.linePic" />
      <div class="name-box">
        <p class="name">{{ item.title }}</p>
        <p class="value" v-if="item.num > 0">
          <span class="num">{{ item.num }}</span
          >({{ item.unit }})
        </p>
        <p class="value" v-else>
          -（个）
        </p>
      </div>
    </div>
    <!--
    <div class="pp-item pp-item1">
      <img src="~images/index/cyzl/zline.png" />
      <div class="name-box">
        <p class="name">广东荔枝小镇</p>
        <p class="value"><span class="num">146</span>(个)</p>
      </div>
    </div>
    <div class="pp-item pp-item2">
      <img src="~images/index/cyzl/zline.png" />
      <div class="name-box">
        <p class="name">广东荔枝小镇</p>
        <p class="value"><span class="num">146</span>(个)</p>
      </div>
    </div>
    <div class="pp-item pp-item3">
      <img src="~images/index/cyzl/qline.png" />
      <div class="name-box">
        <p class="name">广东荔枝小镇</p>
        <p class="value"><span class="num">146</span>(个)</p>
      </div>
    </div>
    <div class="pp-item pp-item4">
      <img src="~images/index/cyzl/qline.png" />
      <div class="name-box">
        <p class="name">广东荔枝小镇</p>
        <p class="value"><span class="num">146</span>(个)</p>
      </div>
    </div>
    <div class="pp-item pp-item5">
      <img src="~images/index/cyzl/qline.png" />
      <div class="name-box">
        <p class="name">广东荔枝小镇</p>
        <p class="value"><span class="num">146</span>(个)</p>
      </div>
    </div>
    <div class="pp-item pp-item6">
      <img src="~images/index/cyzl/qline.png" />
      <div class="name-box">
        <p class="name">广东荔枝小镇</p>
        <p class="value"><span class="num">146</span>(个)</p>
      </div>
    </div> -->
  </div>
</template>

<script>
import { getDataBrandHeaddata } from "@/api/schj";
// import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {},
  data() {
    return {
      list: [
        {
          name: "广东荔枝小镇",
          num: 0,
          unit: "个",
          linePic: require("images/index/cyzl/zline.png")
        },
        {
          name: "广东荔枝专业镇",
          num: 5,
          unit: "个",
          linePic: require("images/index/cyzl/zline.png")
        },
        {
          name: "绿色食品",
          num: 111,
          unit: "个",
          linePic: require("images/index/cyzl/qline.png")
        },
        {
          name: "地理标志",
          num: 9,
          unit: "个",
          linePic: require("images/index/cyzl/qline.png")
        },
        {
          name: "有机食品",
          num: 14,
          unit: "个",
          linePic: require("images/index/cyzl/qline.png")
        },
        {
          name: "粤字号品牌",
          num: 123,
          unit: "个",
          linePic: require("images/index/cyzl/qline.png")
        }
      ]
    };
  },
  mounted() {
    this.getBrandsList();
  },
  methods: {
    getBrandsList() {
      getDataBrandHeaddata().then(res => {
        let list = [];
        if (res) {
          res.data.forEach(ele => {
            if (/^广东/.test(ele.title)) {
              ele.linePic = require("images/index/cyzl/zline.png");
              list.push(ele);
            }
          });
          res.data.forEach(ele => {
            if (!/^广东/.test(ele.title)) {
              ele.linePic = require("images/index/cyzl/qline.png");
              list.push(ele);
            }
          });
        }
        this.list = list;
        console.log("list>>>>", this.list);
      });
    },
    onppClick(item) {
      this.$bus.$emit("ppjsclick", item);
    },
    showDt(item) {
      this.$store.dispatch("drawer/setGraphic", item);
      this.$store.dispatch("drawer/setRightComponent", "ssztDrawer");
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.cardContent
  height 100%
  justify-content center
  position relative
  .center-logo
    z-index 1
  .pp-item
    position absolute
    // left calc(50% - 3px)
    // top 20%
    .name-box
      position absolute
      // left 50%
      // top 0
      // transform translate(-50%, -100%)
      // width 165px
      // height 80px
      // background url('~images/index/cyzl/c_bg.png') no-repeat center
      // background-size 100% 100%
      z-index 1
      text-align center
      display flex
      flex-direction column
      justify-content center
      cursor pointer
      .name
        color #fff
        font-size 12px
        margin-bottom 10px
      .value
        color #fed926
        font-size 12px
        .num
          font-size .14rem
          margin-right 5px
  .pp-item1
    left calc(50% - 3px)
    top 22%
    .name-box
      left 50%
      top 0
      transform translate(-50%, -100%)
      width 165px
      height 80px
      background url('~images/index/cyzl/c_bg.png') no-repeat center
      background-size 100% 100%
  .pp-item2
    left calc(50% - 3px)
    bottom 22%
    .name-box
      left 50%
      bottom 0
      transform translate(-50%, 100%)
      width 165px
      height 80px
      background url('~images/index/cyzl/c_bg.png') no-repeat center
      background-size 100% 100%
  .pp-item3
    left 21%
    top 35%
    .name-box
      left 0
      top 0
      transform translate(-85%, -50%)
      width 105px
      height 80px
      background url('~images/index/cyzl/z_bg.png') no-repeat center
      background-size 100% 100%
  .pp-item4
    left 21%
    bottom 35%
    >img
      transform rotateX(180deg) //垂直镜像翻转
    .name-box
      left 0
      bottom 0
      transform translate(-85%, 50%)
      width 105px
      height 80px
      background url('~images/index/cyzl/z_bg.png') no-repeat center
      background-size 100% 100%
  .pp-item5
    right 21%
    top 35%
    >img
      transform rotateY(180deg) //水平镜像翻转
    .name-box
      right 0
      top 0
      transform translate(80%, -50%)
      width 105px
      height 80px
      background url('~images/index/cyzl/z_bg.png') no-repeat center
      background-size 100% 100%
  .pp-item6
    right 21%
    bottom 35%
    >img
      transform rotate(180deg) //水平垂直镜像翻转
    .name-box
      right 0
      bottom 0
      transform translate(80%, 50%)
      width 105px
      height 80px
      background url('~images/index/cyzl/z_bg.png') no-repeat center
      background-size 100% 100%

@media (max-width 1280px)
  // .tableBody
  //   font-size 0.08rem
</style>
